<template>
    <span>{{ user.first_name }}</span>
</template>

<script setup>
import { useUserStore } from '@/stores/user'
const user = useUserStore()
</script>
